import { isFunction } from "lodash";
import { useMutation } from "react-query";
import { reactQueryPatch } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

interface UseMarkChatRoomAsReadProps {
  onSuccess?: () => void;
}

export const useMarkChatRoomAsRead = ({
  onSuccess,
}: UseMarkChatRoomAsReadProps = {}) => {
  const { mutateAsync: markChatRoomAsRead } = useMutation(
    ({ uuid }: { uuid: string }) =>
      reactQueryPatch(
        internalApi.chatRooms.markAsRead({
          uuid,
        }),
      ),
    {
      onSuccess: () => {
        isFunction(onSuccess) && onSuccess();
      },
      onError: (err: { message: string }) => {
        console.error(err.message);
      },
    },
  );

  return { markChatRoomAsRead };
};
